import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PublicShell } from "@/components/layouts/AppShell";

export const Route = createFileRoute("/auth/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PublicShell>
      <Outlet />
    </PublicShell>
  );
}
